var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoleculeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C8 5.55636 7.84855 6.07734 7.58464 6.52398L9.75178 8.69112C10.3925 8.25495 11.1665 8 12 8C13.296 8 14.4481 8.61637 15.179 9.57196L18.0062 8.15838C18.0021 8.10613 18 8.05331 18 8C18 6.89543 18.8954 6 20 6C21.1046 6 22 6.89543 22 8C22 9.10457 21.1046 10 20 10C19.4928 10 19.0296 9.81118 18.6771 9.49999L15.8506 10.9132C15.9479 11.2588 16 11.6233 16 12C16 13.3502 15.3311 14.5441 14.3065 15.2684L16.4637 18.0727C16.6344 18.0253 16.8142 18 17 18C18.1046 18 19 18.8954 19 20C19 21.1046 18.1046 22 17 22C15.8954 22 15 21.1046 15 20C15 19.6305 15.1002 19.2844 15.2749 18.9874L12.8989 15.8986C12.6099 15.9649 12.3091 16 12 16C10.5665 16 9.30917 15.246 8.60293 14.1129L5.97597 15.6891C5.99179 15.7904 6 15.8942 6 16C6 17.1046 5.10457 18 4 18C2.89543 18 2 17.1046 2 16C2 14.8954 2.89543 14 4 14C4.45207 14 4.86911 14.15 5.20407 14.4029L8.05926 12.6898C8.0203 12.4657 8 12.2352 8 12C8 11.1665 8.25495 10.3925 8.69112 9.75178L6.52398 7.58464C6.07734 7.84855 5.55636 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoleculeAlt);
export default __webpack_public_path__ + "static/media/molecule-alt.e020c9d196f4ee106eab4117b9f31ebe.svg";
export { ForwardRef as ReactComponent };